var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeletionRequest(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-Delete_Account"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 25
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Delete_Account",
    "data-name": "Delete Account",
    clipPath: "url(#clip-Delete_Account)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_328",
    "data-name": "Group 328",
    transform: "translate(0 -0.186)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_309",
    "data-name": "Group 309",
    transform: "translate(16.637 5.509)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_306",
    "data-name": "Group 306",
    transform: "translate(0.596 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_305",
    "data-name": "Group 305"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_244",
    "data-name": "Path 244",
    d: "M45.353,373.6a1.358,1.358,0,0,1-1.076-.523,1.248,1.248,0,0,1-.141-1.255,1.143,1.143,0,0,1,1.083-.646.765.765,0,0,1,.652.4.512.512,0,0,1-.009.474.4.4,0,0,1-.464.182.346.346,0,0,1-.207-.208.314.314,0,0,1,.018-.268.116.116,0,1,1,.2.117.087.087,0,0,0,0,.07.12.12,0,0,0,.065.069.17.17,0,0,0,.187-.081.281.281,0,0,0,0-.255.541.541,0,0,0-.458-.266.908.908,0,0,0-.856.513,1.01,1.01,0,0,0,.116,1.015,1.129,1.129,0,0,0,1.926-.257.991.991,0,0,0-.3-1.118.116.116,0,0,1,.142-.185,1.231,1.231,0,0,1,.373,1.388,1.354,1.354,0,0,1-1.178.834Z",
    transform: "translate(-43.794 -370.938)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_245",
    "data-name": "Path 245",
    d: "M45.088,373.568a1.587,1.587,0,0,1-1.262-.616,1.488,1.488,0,0,1-.166-1.5,1.382,1.382,0,0,1,1.311-.78,1.072,1.072,0,0,1,.671.287.362.362,0,0,1,.471-.038,1.472,1.472,0,0,1,.448,1.658,1.593,1.593,0,0,1-1.384.983Zm-.363-2.166a.677.677,0,0,0-.431.353.78.78,0,0,0,.091.773.905.905,0,0,0,.7.338h.048a.906.906,0,0,0,.769-.538.778.778,0,0,0-.032-.611.664.664,0,0,1-.075.185.64.64,0,0,1-.743.284.585.585,0,0,1-.349-.347A.552.552,0,0,1,44.725,371.4Z",
    transform: "translate(-43.529 -370.672)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_308",
    "data-name": "Group 308",
    transform: "translate(0 3.294)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_307",
    "data-name": "Group 307"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_246",
    "data-name": "Path 246",
    d: "M44.9,382.04a5.252,5.252,0,0,1-.86-.071c-.352-.059-.758-.26-.742-.631.013-.3.3-.482.565-.557a1.991,1.991,0,0,1,1.391.121.117.117,0,0,1-.1.21A1.754,1.754,0,0,0,43.923,381c-.178.05-.389.17-.4.343-.01.234.339.356.547.391a5,5,0,0,0,1.313.044,1.125,1.125,0,0,0,.848-.359,1.348,1.348,0,0,0,.069-1.052,4.874,4.874,0,0,0-.3-1.056,1.58,1.58,0,0,0-.678-.771,1.4,1.4,0,0,0-1.388.145,2.2,2.2,0,0,0-.815,1.238,5.139,5.139,0,0,0-.13,1.545.117.117,0,0,1-.112.121.121.121,0,0,1-.12-.112,5.356,5.356,0,0,1,.139-1.616,2.434,2.434,0,0,1,.906-1.367,1.611,1.611,0,0,1,1.628-.161,1.806,1.806,0,0,1,.784.882,5.049,5.049,0,0,1,.311,1.106,1.546,1.546,0,0,1-.11,1.236,1.386,1.386,0,0,1-1.013.453Q45.153,382.04,44.9,382.04Z",
    transform: "translate(-42.523 -377.958)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_247",
    "data-name": "Path 247",
    d: "M44.63,382.015a5.45,5.45,0,0,1-.9-.075,1.163,1.163,0,0,1-.845-.5l-.013.015a.349.349,0,0,1-.245.112.359.359,0,0,1-.363-.339,5.555,5.555,0,0,1,.147-1.686,2.667,2.667,0,0,1,1-1.5,1.885,1.885,0,0,1,1.868-.178,2.038,2.038,0,0,1,.891,1,5.249,5.249,0,0,1,.327,1.154,1.8,1.8,0,0,1-.15,1.423,1.6,1.6,0,0,1-1.178.547Q44.9,382.015,44.63,382.015Zm-.5-1.1a1.478,1.478,0,0,0-.4.056.4.4,0,0,0-.226.131.666.666,0,0,0,.353.146,4.772,4.772,0,0,0,1.251.042.938.938,0,0,0,.682-.264,1.183,1.183,0,0,0,.028-.867,4.687,4.687,0,0,0-.278-1.005,1.353,1.353,0,0,0-.571-.659,1.184,1.184,0,0,0-1.148.128,1.969,1.969,0,0,0-.723,1.108,3.9,3.9,0,0,0-.126.909,1.152,1.152,0,0,1,.567-.344,2.25,2.25,0,0,1,1.556.135.351.351,0,0,1,.163.469.359.359,0,0,1-.469.162A1.516,1.516,0,0,0,44.126,380.916Z",
    transform: "translate(-42.258 -377.699)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_310",
    "data-name": "Group 310",
    transform: "translate(1.148 8.497)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_248",
    "data-name": "Path 248",
    d: "M21.163,393.549H12.5a3.292,3.292,0,0,1-3.288-3.288V377.515a.469.469,0,0,1,.937,0v12.746a2.354,2.354,0,0,0,2.351,2.351h8.661a2.354,2.354,0,0,0,2.351-2.351v-2.434a.469.469,0,1,1,.937,0v2.434A3.292,3.292,0,0,1,21.163,393.549Z",
    transform: "translate(-9.214 -377.046)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_311",
    "data-name": "Group 311",
    transform: "translate(0 0.685)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_249",
    "data-name": "Path 249",
    d: "M7.233,367.887a.469.469,0,0,1-.187-.9l15.155-6.57a.469.469,0,0,1,.373.86l-15.155,6.57A.469.469,0,0,1,7.233,367.887Z",
    transform: "translate(-6.764 -360.379)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_312",
    "data-name": "Group 312",
    transform: "translate(3.868 0.186)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_250",
    "data-name": "Path 250",
    d: "M16.611,365.157a.469.469,0,0,1-.428-.277c-.357-.8-.663-1.467-.992-2.131a1.273,1.273,0,0,1-.171-.658c.139-2.128,3.768-2.667,4.494-2.753a2.241,2.241,0,0,1,2.382,1.188.469.469,0,0,1-.82.455,1.315,1.315,0,0,0-1.452-.712c-1.437.171-3.6.814-3.669,1.884a.906.906,0,0,0,.075.18c.336.678.646,1.356,1.008,2.165a.468.468,0,0,1-.236.619A.462.462,0,0,1,16.611,365.157Z",
    transform: "translate(-15.018 -359.315)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_313",
    "data-name": "Group 313",
    transform: "translate(6.29 11.669)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_251",
    "data-name": "Path 251",
    d: "M20.651,392.387a.469.469,0,0,1-.469-.469v-7.636a.469.469,0,1,1,.937,0v7.636A.469.469,0,0,1,20.651,392.387Z",
    transform: "translate(-20.182 -383.813)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_314",
    "data-name": "Group 314",
    transform: "translate(10.277 11.669)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_252",
    "data-name": "Path 252",
    d: "M29.159,392.387a.469.469,0,0,1-.469-.469v-7.636a.469.469,0,1,1,.937,0v7.636A.469.469,0,0,1,29.159,392.387Z",
    transform: "translate(-28.69 -383.813)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_315",
    "data-name": "Group 315",
    transform: "translate(12.344 3.085)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_253",
    "data-name": "Path 253",
    d: "M39.428,378.156a6.328,6.328,0,1,1,6.328-6.328A6.335,6.335,0,0,1,39.428,378.156Zm0-11.718a5.391,5.391,0,1,0,5.39,5.391A5.4,5.4,0,0,0,39.428,366.437Z",
    transform: "translate(-33.1 -365.5)",
    fill: "#fff"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeletionRequest);
export default __webpack_public_path__ + "static/media/deletionRequest.26a9fd803d68bf47ac113ccbb4edffe1.svg";
export { ForwardRef as ReactComponent };